import { Action, createAction } from 'redux-act';

import Feedback from '../../../models/interfaces/Feedback';
import TimestampPayload from '../TimestampPayload';

export interface SendFeedbackPayload {
  feedback: Feedback;
}
export const sendFeedback = createAction<SendFeedbackPayload>('SEND_FEEDBACK');
export type SendFeedbackActionType = Action<SendFeedbackPayload>;

export interface FeedbackReceivedPayload extends TimestampPayload {
  feedback: Feedback;
}
export const feedbackReceived = createAction<FeedbackReceivedPayload>('FEEDBACK_RECEIVED');

export interface FeedbackFailedPayload extends TimestampPayload {
  feedback: Feedback;
}
export const feedbackFailed = createAction<FeedbackFailedPayload>('FEEDBACK_FAILED');
